var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckTransparentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5323 27.7335H37.3323V23.4668H22.399C21.2256 23.4668 20.2656 24.4268 20.2656 25.6001V37.3335H22.399C22.399 39.1041 23.8283 40.5335 25.599 40.5335C27.3696 40.5335 28.799 39.1041 28.799 37.3335H35.199C35.199 39.1041 36.6283 40.5335 38.399 40.5335C40.1696 40.5335 41.599 39.1041 41.599 37.3335H43.7323V32.0001L40.5323 27.7335ZM25.599 38.9335C24.7136 38.9335 23.999 38.2188 23.999 37.3335C23.999 36.4481 24.7136 35.7335 25.599 35.7335C26.4843 35.7335 27.199 36.4481 27.199 37.3335C27.199 38.2188 26.4843 38.9335 25.599 38.9335ZM39.999 29.3335L42.0896 32.0001H37.3323V29.3335H39.999ZM38.399 38.9335C37.5136 38.9335 36.799 38.2188 36.799 37.3335C36.799 36.4481 37.5136 35.7335 38.399 35.7335C39.2843 35.7335 39.999 36.4481 39.999 37.3335C39.999 38.2188 39.2843 38.9335 38.399 38.9335Z",
    fill: "#A9BAC8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    stroke: "#A9BAC8",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTransparentIcon);
export default __webpack_public_path__ + "static/media/TruckTransparentIcon.213cbb413f20abc7e4ce2473c5859ed7.svg";
export { ForwardRef as ReactComponent };